import { hash, stream } from "../games-shelf/cover";

/** A little blocky character, drawn from a person's id: every field picks one part. */
export interface UserMark {
  /** Which ground, head tone, eyes, mouth, top, side and cheek parts it wears. */
  ground: number;
  tone: number;
  eyes: number;
  mouth: number;
  top: number;
  side: number;
  cheek: number;
  /** Head size in a 32 box: width and height, bottom edge fixed at 28. */
  w: number;
  h: number;
}

export const GROUNDS = 4;
export const TONES = 4;
export const EYES = 6;
export const MOUTHS = 5;
export const TOPS = 6;
export const SIDES = 3;
export const CHEEKS = 2;
export const HEAD_W = [18, 20, 22] as const;
export const HEAD_H = [16, 18, 20] as const;

/** Distinct characters the parts can make. */
export const CHARACTERS =
  GROUNDS * TONES * EYES * MOUTHS * TOPS * SIDES * CHEEKS * HEAD_W.length * HEAD_H.length;

/** A person's character, made from their id alone: the same id always draws the same one. */
export function userMarkFor(id: string): UserMark {
  const next = stream(hash(`user:${id}`));
  const pick = (n: number) => Math.floor(next() * n);
  return {
    ground: pick(GROUNDS),
    tone: pick(TONES),
    eyes: pick(EYES),
    mouth: pick(MOUTHS),
    top: pick(TOPS),
    side: pick(SIDES),
    cheek: pick(CHEEKS),
    w: HEAD_W[pick(HEAD_W.length)] ?? 20,
    h: HEAD_H[pick(HEAD_H.length)] ?? 18,
  };
}
